// @ts-nocheck
import React, { useState } from 'react'
import {
	Button,
	Link,
} from '../../components/StyledComponents'
import { Page } from '../../components/ui/Page'
import { Title } from '../../components/layout/Title'
import { Stepper } from '../../components/features/Stepper'
import { Body } from '../../components/layout/Body'
import { BackArrow, PayLater } from '../../components/Icons'
import DateFormat from '../../lib.r2/utils/DateFormat'
import Store from '../../store/Store'
import { bookingStepLabels } from './bookingStepLabels'
import CheckoutForm from './Checkout'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

const safeValue = (value) => {
	if (value === null || value === undefined || value === '') return '-'
	if (typeof value === 'object') return JSON.stringify(value)
	return String(value)
}

// ============================================================================
// 5. Bezahlen
const BookingPage5 = () => {
	const bookingData = Store.bookingData
	const priceData = bookingData?.priceData
	const [showDetails, setShowDetails] = useState(false)

	if (!bookingData) return null

	const totalPrice =
		bookingData?.price ||
		priceData?.finalPriceWithoutPrivacy ||
		priceData?.finalPriceWithoutPrivat ||
		priceData?.finalPrice ||
		0

	const savedDateRange =
		bookingData?._savedDates ||
		(bookingData?.dateFrom && bookingData?.dateTo
			? `${DateFormat(bookingData.dateFrom, 'dd.mm.yyyy')} - ${DateFormat(
				bookingData.dateTo,
				'dd.mm.yyyy'
			)}`
			: '')

	const productKey =
		bookingData?.mission === 'Landwirtschaft' ? 'l2' : 'v2'

	const purposesContent = Array.isArray(bookingData?.purposes)
		? bookingData.purposes
		: []

	return (
		<div className="max-w-[1100px] mx-auto">
			<Page>
				<Body>
					<Stepper numSteps={5} step={4} labels={bookingStepLabels} />
					<div className="w-full pt-6">
						<Title>Flug reserviert, jetzt bezahlen!</Title>

						{/* <div className="mt-8 mb-12">
							<Link
								data-pw="link-back-to-overview"
								onClick={() => Store.navigate('dashboard')}
							>
								<span className="inline-flex items-center gap-2 text-[18px]">
									<BackArrow />
									Zurück zur Übersicht
								</span>
							</Link>
						</div> */}

						<div className="grid grid-cols-1 lg:grid-cols-[1.05fr_0.95fr] gap-16 items-start">
							{/* LEFT */}
							<div>
								<div className="border border-[#4B4B4B] rounded-[32px] p-8 bg-white min-h-[760px]">
									<CheckoutForm
										productKey={productKey}
										orderId={Store.latestOrderId}
										onPaymentSuccess={() => {
											window.location.hash = '#/booking/page_6'
										}}
									/>
								</div>
							</div>

							{/* RIGHT */}
							<div>
								<div className="bg-[#EEF5FB] rounded-[28px] p-8 shadow-sm">
									<div className="flex items-start justify-between gap-4">
										<h2 className="text-2xl font-semibold">
											Bestellung Drohnenflug
										</h2>
										{/* <div className="text-2xl font-semibold">
											€ {Number(totalPrice).toFixed(2)}
										</div> */}
									</div>

									<div className="mt-8 text-[16px] text-[#666]">
										<div>Auftragsnummer:</div>
										<div>
											{Store.latestOrderId ||
												bookingData?.id ||
												'-'}
										</div>
									</div>
									<div className='border-t border-[#C6D4E2] mt-6'>


										{showDetails && (
											<div className="mt-8 text-[15px] space-y-4">
												<div className="flex justify-between gap-4">
													<span>Name Ihrer Bestellung</span>
													<span className="text-right">
														{safeValue(bookingData?.name)}
													</span>
												</div>

												<div className="flex justify-between gap-4">
													<span>Anwendungsfall</span>
													<span className="text-right">
														{bookingData.selectedServiceId || bookingData.mission || '-'}
													</span>
												</div>

												<div className="flex justify-between gap-4 items-start">
													<span>Auswertungsart</span>
													<div className="text-right">
														{purposesContent.map((purpose, index) => (
															<div key={`${purpose?.name || 'purpose'}-${index}`}>
																{typeof purpose === 'string' ? purpose : purpose?.name}
															</div>
														))}
													</div>
												</div>

												<div className="flex justify-between gap-4">
													<span>Zeitraum</span>
													<span className="text-right">
														{safeValue(savedDateRange)}
													</span>
												</div>
											</div>
										)}
										<button
											type="button"
											className="mt-8 w-full flex items-center justify-center gap-2 text-[16px] text-[#333]"
											data-pw="button-toggle-details"
											onClick={() => setShowDetails(prev => !prev)}
										>
											{showDetails ? "Details ausblenden" : "Details einblenden"}

											{showDetails ? (
												<KeyboardArrowUpIcon fontSize="small" />
											) : (
												<KeyboardArrowDownIcon fontSize="small" />
											)}
										</button>
									</div>

								</div>

								<div className="mt-12 flex items-start gap-3 text-[#0063A3]">
									<div className="w-[22px] h-[22px] min-w-[22px] rounded-full bg-[#0063A3] text-white flex items-center justify-center text-[14px] font-bold">
										i
									</div>
									<p className="text-[16px] text-[#0063A3]">
										Bitte beachten Sie, dass Ihr geplanter
										Drohnenflug
										{savedDateRange
											? ` am ${savedDateRange}`
											: ''}
										{' '}
										aufgrund der Wetterbedingungen
										verschoben werden kann. Wir werden Sie
										über alle Änderungen auf dem Laufenden
										halten.
									</p>
								</div>

								<div className="mt-20">
									<Button
										data-pw="button-later-pay"
										className="border border-[#E1320F] text-[#E1320F] bg-white"
										onClick={() =>
											Store.navigate('dashboard')
										}
									>
										<PayLater /> Später bezahlen
									</Button>
								</div>
							</div>
						</div>
					</div>
				</Body>
			</Page>
		</div>
	)
}

export default BookingPage5